<template>
    <navbar position="fixed" :transparent="transparent" :color-on-scroll="colorOnScroll"  menu-classes="ml-auto">
        <template slot-scope="{toggle, isToggled}">
                <router-link v-popover:popover1 class="navbar-brand" to="/">
                    <h3 class="mensi_a_tlustsi">HIPPOWARE</h3>
                </router-link>
                <el-popover ref="popover1" popper-class="popover" placement="bottom" width="200" trigger="hover">
                    <div class="popover-body">

                    </div>
                </el-popover>
        </template>
        <template slot="navbar-menu">
            <!-- <li class="nav-item">
                <a class="nav-link" href="/"> DevStack </a>
            </li>            
            <li class="nav-item">
                <a class="nav-link" href="/"> Dokumentace </a>
            </li>            
            <li class="nav-item">
                <a class="nav-link" href="/"> Download </a>
            </li>            
            <li class="nav-item">
                <a class="nav-link" href="/"> Kontakty </a>
            </li>            
            

            <li class="nav-item">
                <nav-link class="nav-link btn btn-dark" to="/">
                    <i class="now-ui-icons tech_mobile"></i> Registrace
                </nav-link>
            </li> -->

        </template>
    </navbar>
</template>

<script>
  import { DropDown, NavbarToggleButton, Navbar, NavLink } from '@/components';
  import { Popover } from 'element-ui'
  export default {
    name: 'main-navbar',
    props: {
      transparent: Boolean,
      colorOnScroll: Number,
    },
    components: {
      DropDown,
      Navbar,
      NavbarToggleButton,
      NavLink,
      [Popover.name]: Popover
    }
  }
</script>

<style scoped>
.mensi_a_tlustsi {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 0px;
}

</style>
